"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    getHoveredDateRange: ()=>getHoveredDateRange,
    getFormattedDates: ()=>getFormattedDates,
    shouldAutoClose: ()=>shouldAutoClose
});
const external_date_fns_namespaceObject = require("date-fns");
function getFormattedDates({ dates, dateFormat, displayNights }) {
    if (!dates) return '';
    if ('from' in dates) {
        const range = dates;
        const fromDate = range.from ? (0, external_date_fns_namespaceObject.format)(range.from, dateFormat) : '';
        const toDate = range.to ? (0, external_date_fns_namespaceObject.format)(range.to, dateFormat) : '';
        let formattedDates = '';
        if (fromDate && toDate) if (displayNights) {
            const diffInDays = (0, external_date_fns_namespaceObject.differenceInCalendarDays)(toDate, fromDate);
            formattedDates = `${fromDate} - ${toDate} (${diffInDays} nights)`;
        } else formattedDates = `${fromDate} - ${toDate}`;
        return formattedDates;
    }
    if (Array.isArray(dates)) return dates.map((date)=>(0, external_date_fns_namespaceObject.format)(date, dateFormat)).join(', ');
    return (0, external_date_fns_namespaceObject.format)(dates, dateFormat);
}
function shouldAutoClose(mode, newDates) {
    return 'single' === mode || 'range' === mode && 'object' == typeof newDates && null !== newDates && 'from' in newDates && 'to' in newDates && null != newDates.from && null != newDates.to && newDates.from.getTime() !== newDates.to.getTime() || 'multiple' === mode && Array.isArray(newDates) && newDates.length >= 2;
}
function isDateRange(value) {
    if ('object' == typeof value && null !== value) return 'from' in value && 'to' in value;
    return false;
}
function getHoveredDateRange(mode, day, selectedDates) {
    if ('range' === mode && void 0 !== selectedDates && isDateRange(selectedDates)) {
        if (selectedDates.from && (0, external_date_fns_namespaceObject.isAfter)(day, selectedDates.from) && (void 0 === selectedDates.to || (0, external_date_fns_namespaceObject.isEqual)(selectedDates.from, selectedDates.to))) return (0, external_date_fns_namespaceObject.eachDayOfInterval)({
            start: selectedDates.from,
            end: day
        });
    }
    return [];
}
exports.getFormattedDates = __webpack_exports__.getFormattedDates;
exports.getHoveredDateRange = __webpack_exports__.getHoveredDateRange;
exports.shouldAutoClose = __webpack_exports__.shouldAutoClose;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "getFormattedDates",
    "getHoveredDateRange",
    "shouldAutoClose"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
